import script from "./ApplyOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplyOrders.vue?vue&type=script&setup=true&lang=ts"

import "./ApplyOrders.vue?vue&type=style&index=0&id=38e80032&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e80032"]])

export default __exports__